<template>
  <nav class="nav">
    <img class="nav__logo" :src="navLogo"/>
    <ul class="nav__list" ref="nav">
      <div class="nav__dropdown-toggle-btn" @click="toggleNav">
        <img class="nav__mobile-menu-button" :src="navMenuIcon" />
      </div>
      <li class="nav__item" v-for="(link, index) in navLinks" :key="index"
        @click="nav(link) in navLinks">
        <router-link :to="link.path" class="nav__router-links">{{ link.text }}</router-link>
      </li>
      <li class="nav__item">
        <a class="nav__link" href="#about">About</a>
      </li>
      <li class="nav__item">
        <a class="nav__link" href="#projects">Projects</a>
      </li>
      <li class="nav__item">
        <a class="nav__link" href="#contact">Contact</a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  props: ["navLinks", "navMenuIcon", "navLogo"],
  methods: {
    toggleNav() {
      const nav = this.$refs.nav.classList;
      nav.contains("active") ? nav.remove("active") : nav.add("active");
    }
  },
  data() {
    return {
      hover: false
    };
  }
};
</script>
<style lang="scss">
@import "~@/assets/styles/main.scss";
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue